module.exports = __webpack_public_path__ + "front/img/kv03.537eb590.png";